import { stripExtension } from "../../utils";
import type { DataLoadFile } from "./consts";

export const errorMessage = (e: unknown): string => (e as Error)?.message || "Unknown error";

/** Sheet instructions the onboarder actually filled in; blank ones must not reach the transform. */
export const nonEmptyTabInstructions = (tabInstructions: Record<string, string>): Record<string, string> =>
	Object.fromEntries(Object.entries(tabInstructions).filter(([, value]) => value.trim()));

/**
 * What actually gets sent to the loader. In direct mode that is the original file, byte for byte —
 * anything else would make "upload as-is" a lie. In transform mode it is the preview's filtered blob
 * when the onboarder opened the preview, and the raw transform output when they did not.
 */
export const payloadFor = (entry: DataLoadFile): File => {
	if (entry.mode === "direct") return entry.file;
	const prefix = entry.kind === "roster" ? "transformed_nurses" : "transformed";
	const blob = entry.filteredBlob ?? new Blob([entry.transformedData as ArrayBuffer], { type: "text/csv" });
	return new File([blob], `${prefix}_${stripExtension(entry.file.name, "file")}.csv`, { type: "text/csv" });
};
